module.exports = __webpack_public_path__ + "static/media/adv6.b73753bc.jpg";